<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      @goBack="goBack"
      @close="close"
      @reload="loadData"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <div class="content__title__container get-height">
          <h2 class="content__title">{{ data.name || '-' }}</h2>
          <div v-if="isValidObject(drawerData) && drawerData.employee && drawerData.employee.externalId">
            <span class="gray-6--text">{{ $t(`${namespace}.externalId`) }}:</span> {{ drawerData.employee.externalId }}
          </div>
        </div>

        <TabInfo
          v-if="hasRole('employee', 'ROLE_GET_EMPLOYEE_ID')"
          :data="drawerData"
          @change="change"
        />

        <EmptyState
          v-else
          image="employee"
          :imageSize="120"
          class="px-4"
        >
          <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
        </EmptyState>
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="accent" />
      </div>
    </div>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole, isObject, calcContentHeight } from 'utils/functions'
import Header from './Header'
import TabInfo from './TabInfo'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Employee',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Array,
      default: () => []
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    Header,
    TabInfo,
    EmptyState
  },
  computed: {
    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.creditPolicy.body',
      currentStatus: null,
      drawerData: {},
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isObject(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.currentStatus === STATUS_IS_LOADING || !this.hasRole('employee', 'ROLE_GET_EMPLOYEE_ID')) {
        this.currentStatus = STATUS_SUCCESS
        return
      }

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { data: res } = await this.$apiService.getEmployeeById(this.data.id)

        this.drawerData = {
          employeeId: this.data.id,
          ...res.data
        }

        this.$emit('updateHistory', {
          drawerType: 'creditPolicy',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}

.content__title__container {
  padding: 22px 24px;
  text-align: center;
}

.content__title {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 800;
}
</style>
